var g_KlaviyoIdentifyURL = "https://a.klaviyo.com/api/identify";
var g_KlaviyotrackURL = "https://a.klaviyo.com/api/track";
var g_KlaviyoPublicAPIKey = "V5VVa5";

function RestSendToKlaviyo(properties, url, cb) {
  var dataToSend = { data: JSON.stringify(properties) };
  console.log(dataToSend);
  var params = new URLSearchParams(dataToSend);

  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4) {
      cb(xhr);
    }
  };

  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhr.setRequestHeader("Accept", "text/html");
  xhr.send(params);
}

function utmParams() {
  // template:
  // utm_source=google&utm_medium=cpc&utm_campaign={campaignid}&utm_content={creative}&utm_term={keyword}&adgroupid={adgroupid}&adid={creative}
  const urlParams = new URLSearchParams(window.location.search);
  const utmParams = {
    utm_source: urlParams.get("utm_source"),
    utm_medium: urlParams.get("utm_medium"),
    utm_campaign: urlParams.get("utm_campaign"),
    utm_term: urlParams.get("utm_term"),
    utm_content: urlParams.get("utm_content"),
  };
  // filter out nulls
  const filteredUtmParams = Object.fromEntries(
    Object.entries(utmParams).filter(([_, v]) => v != null),
  );
  return filteredUtmParams;
}

//https://developers.klaviyo.com/en/docs/introduction_to_the_klaviyo_object

// function KlaviyoTrackV2(customerData, data, cb) {
//   klaviyo.identify(customerData, function () {
//     klaviyo.track(data.event, data.trackData);
//     {
//       cb();
//     }
//   });
// }

function KlaviyoTrackV2(customerData, data, cb) {
  var done = false;

  function finish() {
    if (done) return;
    done = true;
    if (typeof cb === "function") {
      try {
        cb();
      } catch (e) {}
    }
  }

  // Safety timeout — guarantees cb always fires
  var timer = setTimeout(finish, 800);

  try {
    var k = window.klaviyo;

    // If Klaviyo is blocked or missing → fail fast, don't block
    if (!k) {
      clearTimeout(timer);
      return finish();
    }

    // Try identify (but do NOT rely on its callback)
    try {
      if (typeof k.identify === "function") {
        k.identify(customerData, function () {});
      }
    } catch (e) {
      console.warn("Klaviyo identify failed:", e);
    }

    // Try track
    try {
      if (typeof k.track === "function") {
        k.track(data.event, data.trackData);
      }
    } catch (e) {
      console.warn("Klaviyo track failed:", e);
    }

    clearTimeout(timer);
    finish();
  } catch (e) {
    console.warn("Klaviyo error:", e);
    clearTimeout(timer);
    finish();
  }
}
